module.exports = __webpack_public_path__ + "img/shower.0afd30de.svg";